import script from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=js"

import "./UnauthorizedView.vue?vue&type=style&index=0&id=e294b592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e294b592"]])

export default __exports__